import { sendSumoLog } from './sumoLogger';

export const fetchTicketDetail = async (ticketID, token, dispatch) => {
  const requestURL = encodeURI(
    `${process.env.REACT_APP_COUCHBASE_URL}/lmark/${ticketID}`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });
    if (!data.ok) {
      const errorType = 'fetchTicketDetail';
      const message = `${data.status} - System could not find a ticket with ID of ${ticketID} . This ticket may not be available anymore.`;
      const errorCode = data.status;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return { errorType, message };
    }
    return await data.json();
  } catch (error) {
    const message = `Fetching ticket details for ${ticketID} failed`;
    sendSumoLog(error, message, dispatch);
    return {};
  }
};
